import _ from 'lodash';
import {writable} from 'svelte/store';
import storage from './storage.js';

// хранилище параметров
const PARAMETERS = {};
export const parameter = (key, defaults = '') => {
    if (PARAMETERS[key]) {
        return PARAMETERS[key];
    }
    const store = writable(defaults);

    return PARAMETERS[key] = store;
};

// работа с API
const API_HOST = 'https://api.trademaster.pro/';
const API_VER = 'plisse/';


export const network = {
    item: {
        idTovar: 0,
        type: '', // fullDisplayPath
        name: '',
        subname: '',
        title: '',
        params: {
            ind1: '',
            ind2: '',
            ind3: '',
            ind4: '',
            ind5: '',
        },
        price: {
            rozn: 0,
            opt: 0,
            sebest: 0,
            _precision: undefined,
        },
        oprice: {
            rozn: 0,
            opt: 0,
            sebest: 0,
            _precision: undefined,
        },
        comment: '',
        quantity: 0,
        maxDay: 0,
        materials: {
            // 'title': {
            //     id: 0,
            //     type: 'edIzmer',
            //     spis: 0,
            //     percent: 0,
            //     oprice: {
            //         rozn: 0,
            //         opt: 0,
            //         sebest: 0,
            //     },
            //     price: {
            //         rozn: 0,
            //         opt: 0,
            //         sebest: 0,
            //     },
            //     count: 0
            // }
        },
        vStrukture: 10,
    },

    request: async (data) => {
        let param = {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            },
            domain: API_HOST + API_VER,
            endpoint: '',
            params: null,
            body: null,
        };
        data = _.extend(param, data);

        let url = data.domain + data.endpoint + '?apikey=' + APP_KEY + (data.params ? '&' + data.params : '');
        const method = data.method.toUpperCase();
        // Пустое тело у POST на iOS не завершает fetch: сервер заказ создаёт, а ответ до страницы не доходит.
        const body = data.body ?? (method === 'POST' ? '' : undefined);
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), 30000);

        try {
            let response = await fetch(url, {
                method,
                headers: data.headers,
                cache: 'no-store',
                body,
                signal: controller.signal,
            });

            if (!response.ok) {
                throw new Error('Сервер ответил ' + response.status);
            }

            const text = await response.text();
            if (!text) {
                return null;
            }
            try {
                return JSON.parse(text);
            } catch (parseError) {
                throw new Error((text || parseError.message || '').slice(0, 200) || response.statusText);
            }
        } catch (error) {
            if (error && error.name === 'AbortError') {
                throw new Error('Сервер не ответил вовремя');
            }
            throw error;
        } finally {
            clearTimeout(timer);
        }
    },

    get: async (endpoint, data) => {
        // В теле, не в query: nginx отвечает 414 на URL длиннее ~8 КБ, а Safari на таком URL не забирает ответ.
        const body = new URLSearchParams(data || {}).toString();
        return await network.request({method: 'post', endpoint, body});
    },

    post: async (endpoint, data) => {
        const body = new URLSearchParams();
        Object.keys(data || {}).forEach((key) => {
            const value = data[key];
            if (value === undefined || value === null) return;
            body.append(key, String(value));
        });

        return await network.request({method: 'post', endpoint, body: body.toString()});
    },

    fetch_data: async (tip, ind1 = '', ind2 = '', ind3 = '') => {
        let $user = store('credential', 'getAuth').get();

        return await network.get('getIzdelieShablon', {tip, ind1, ind2, ind3, idSklad: $user.idSklad});
    },

    fetch_material: async (ind2, ind5, vstr) => {
        return await network.get('getMaterial', {ind2, ind5, vstr});
    },

    fetch_ind: async (tip) => {
        return await network.get('getInd', {tip});
    },

    fetch_ind2: async (tip) => {
        return await network.get('getInd2', {tip});
    },

    fetch_delivery: async () => {
        let $user = store('credential', 'getAuth').get();

        return await network.get('getDostavka', {idSklad: $user.idSklad});
    },

    fetch_painting: async () => {
        return await network.get('getPainting');
    },

    fetch_zamer: async () => {
        let $user = store('credential', 'getAuth').get();

        return await network.fetch_proxy(`EXEC getZamer @idSklad = ${$user.idSklad}`, {one: true});
    },

    fetch_tovar: async (idTovar) => {
        return await network.fetch_proxy(`EXEC tovarID @tovar = ${parseInt(idTovar)}`, {one: true});
    },

    fetch_proxy: async (query, params = {}) => {
        return await network.get('proxy', _.merge({}, {query}, params));
    },

    fetch_tv: async (idSklad) => {
        return await network
            .fetch_proxy(`EXEC getTV @idSklad = ${parseInt(idSklad)}`)
            .then((rows) => rows.map((row) => ({id: parseInt(row.idTV), tv: row.nameTV, tvInfo: row.adresTV})));
    },

    send_window_active: async () => {
        let $user = store('credential', 'getAuth').get();

        return await network.fetch_proxy(`EXEC saveUserActiv @user = ${$user.id}`, {one: true});
    },

    upload_file: async ({buffer, name}) => {
        let query = new URLSearchParams({apikey: APP_KEY});
        let url = `https://api.trademaster.pro/cdn/post?${query}`;

        let fd = new FormData();
            fd.append('file', new Blob([buffer]), name);

        let response = await fetch(url, {
            method: 'POST',
            cache: 'no-cache',
            body: fd,
        });

        return await response.json();
    },

    // хелперы по созданию и обновлению продукта
    create: async (item, calc) => {
        let result = await network.get('addTovar', {
            name: item.title,
            artikul: item.comment,
            price: item.price.rozn,
            opt_price: item.price.opt,
            sebestomost: item.price.sebest,
            ind1: item.params.ind1 || '',
            ind2: item.params.ind2 || '',
            ind3: item.params.ind3 || '',
            ind4: item.params.ind4 || '',
            ind5: item.params.ind5 || '',
            foto_small: item.params.foto_small || '',
            vStrukture: item.vStrukture,
            calc,
        });

        if (result) {
            let id = result.idTovar;

            let xml = '<Attributes>';

            _.forEach(item.materials, (material) => {
                xml += '<ProductAttribute idTovar="' + material.id + '">';
                xml += '<ProductAttributeValue>';
                xml += '<kolvo>' + material.count + '</kolvo>';
                xml += '<spis>' + material.spis + '</spis>';
                xml += '<percent>' + material.percent + '</percent>';
                xml += '<sum>' + material.price.rozn + '</sum>';
                xml += '</ProductAttributeValue>';
                xml += '</ProductAttribute>';
            });
            xml += '</Attributes>';

            await network.get('configSave', {idIzdelie: id, config: xml});

            return +id;
        }

        return -1;
    },
    update: async (item) => {
        let result = await network.get('correctTovar', {
            name: item.title,
            artikul: item.comment,
            price: item.price.rozn,
            opt_price: item.price.opt,
            sebestomost: item.price.sebest,
            ind1: item.params.ind1 || '',
            ind2: item.params.ind2 || '',
            ind3: item.params.ind3 || '',
            ind4: item.params.ind4 || '',
            ind5: item.params.ind5 || '',
            vStrukture: item.vStrukture,
            foto_small: item.params.foto_small || '',
            idTovar: item.idTovar,
        });

        if (result) {
            let xml = '<Attributes>';

            _.forEach(item.materials, (material) => {
                xml += '<ProductAttribute idTovar="' + material.id + '">';
                xml += '<ProductAttributeValue>';
                xml += '<kolvo>' + material.count + '</kolvo>';
                xml += '<spis>' + material.spis + '</spis>';
                xml += '<percent>' + material.percent + '</percent>';
                xml += '<sum>' + material.price.rozn + '</sum>';
                xml += '</ProductAttributeValue>';
                xml += '</ProductAttribute>';
            });
            xml += '</Attributes>';

            await network.get('configSave', {idIzdelie: item.idTovar, config: xml});

            return +item.idTovar;
        }

        return -1;
    },
    getList: async (settings) => {
        let result
        if (settings.vid === 21){
            result = await network.get('viborkiNeAktualDate', {
                vid: settings.vid,
                idKontr: settings.idKontr,
                idSklad: settings.idSklad,
                data1: settings.data1,
                data2: settings.data2
            });
        }else{
            result = await network.get('viborkiAktualDate', {
                vid: settings.vid,
                idKontr: settings.idKontr,
                idSklad: settings.idSklad,
                data1: settings.data1,
                data2: settings.data2
            });
        }
        return result;
    },
    getSingleItemFromList: async (settings) => {
        let result = await network.get('viborkaActual', {
            vid: settings.vid,
            nomer: settings.nomer
        })
        return result;
    },
}

// работа с хранением данных
const STORES = {};
export const store = (name, endpoint = null, value = '{}') => {
    if (STORES[name]) {
        return STORES[name];
    }

    let loading = writable(false),
        data = writable(JSON.parse(storage.getItem(name) ?? value));

    async function load(params) {
        if (endpoint) {
            loading.set(true);

            let result = await network.get(endpoint, params);
            if (result) {
                data.set(result);
                storage.setItem(name, JSON.stringify(result));
            } else {
                data.set({});
            }
            loading.set(false);

            return result;
        }

        return false;
    }

    function set(params) {
        data.set(params);
        storage.setItem(name, JSON.stringify(params));
    }

    function get() {
        let $val;
        data.subscribe($ => $val = $)();

        return $val;
    }

    function remove() {
        data.set(JSON.parse(value));
        storage.setItem(name, value);
    }

    return STORES[name] = {
        subscribe: data.subscribe,
        get: get,
        set: data.set,
        update: data.update,
        load: load,
        loading: () => loading,
        save: set,
        remove: remove,
    };
};
